import { ofType } from 'redux-observable';
import { Observable, from, of } from 'rxjs';
import { catchError, filter, mergeMap, withLatestFrom } from 'rxjs/operators';
import { Users } from '@bridebook/models';
import { appError } from '@bridebook/web/lib/app/actions';
import { IEpicDeps } from '@bridebook/web/lib/types';
import { IUpdateUserFieldAction, UserActionTypes } from '@bridebook/web/lib/users/action-types';

export const updateUserFieldEpic = (
  action$: Observable<IUpdateUserFieldAction>,
  { state$ }: IEpicDeps,
) =>
  action$.pipe(
    ofType(UserActionTypes.UPDATE_USER_FIELD),
    filter(
      (action): action is IUpdateUserFieldAction =>
        'name' in action.payload && 'value' in action.payload,
    ),
    withLatestFrom(state$),
    mergeMap(
      ([
        {
          payload: { name, value },
        },
        state,
      ]) => {
        const { user } = state.users;
        if (!user) return of();

        return from(Users._.getById(user.id).set({ [name]: value })).pipe(
          mergeMap(() => of()),
          catchError((error: Error) =>
            of(appError({ error, feature: 'Auth' }), {
              type: UserActionTypes.UPDATE_USER_DETAILS_ERROR,
              payload: { name, error },
            }),
          ),
        );
      },
    ),
  );
